import { defineDirective } from "../../exports";
import { ISeedRatePlan } from "../../types";
import { getTotalQtyLabel, SeedRateUnitInfo } from "../../units";
import { IBulkAdjustement } from "./types";

export function createBulkAdjustmentEditor(): ng.IDirective {

    return defineDirective(BulkAdjustmentEditorCtrl, "app/seeds/plan/edit/bulkAdjustQty.html", {
        plan: "<",
        unit: "<",
        bulkAdjustment: "=",
        overlapPct: "<"
    });

}

export class BulkAdjustmentEditorCtrl {

    public plan: ISeedRatePlan
    public bulkAdjustment: IBulkAdjustement
    public unit: SeedRateUnitInfo

    private _currentModeInitQty: number
    private _currentModeInitPct: number

    private _overlapPct: number

    public get mode(): string {
        return this.bulkAdjustment.mode;
    }

    public get displayedQty() {

        const o2 = this._overlapPct || 0;
        const o1 = this.bulkAdjustment ? (this.bulkAdjustment.overlapPct || 0) : o2;

        let qty = this.bulkAdjustment.qty

        if (o1 == o2) return this.bulkAdjustment.qty

        if (o1) qty /= (1 + o1)
        qty *= (1 + o2)

        qty = Math.round(qty)

        return qty

    }

    public get qty(): number {
        return this.qtyMode ? this.bulkAdjustment.qty : this.displayedQty;
    }

    public set qty(value: number) {
        this.bulkAdjustment.qty = value;
        this.bulkAdjustment.pct = this.getPctFromQty();
    }

    public get pct(): number {
        return this.bulkAdjustment.pct;
    }

    public set pct(value: number) {
        this.bulkAdjustment.pct = value;
        this.bulkAdjustment.qty = this.getQtyFromPct();
    }

    get overlapPct() {
        return this._overlapPct
    }

    set overlapPct(value) {
        this._overlapPct = value
    }

    get qtyMode(): boolean {
        return this.mode == "qty";
    }

    get pctMode(): boolean {
        return this.mode == "pct";
    }

    get currentModeValue(): number {
        return (this.qtyMode ? this.qty : this.pct);
    }

    set currentModeValue(value: number) {
        if (this.qtyMode) {
            this.qty = value;
        }
        else {
            this.pct = value;
        }
    }

    public setMode(mode: string) {
        if (mode) {
            this._currentModeInitQty = this.qty;
            this._currentModeInitPct = this.pct;
        }
        this.bulkAdjustment.mode = mode;
    }

    public cancelMode() {
        this.qty = this._currentModeInitQty;
        this.pct = this._currentModeInitPct;
        this.setMode(null);
    }

    private getPctFromQty(): number {

        var qty = this.qty;
        if (qty) {
            return Math.round(qty / this.bulkAdjustment.planQty * 100) / 100;
        }
    }


    private getQtyFromPct(): number {

        const pct = (this.pct || 0)

        if (pct) {
            return Math.round(this.bulkAdjustment.planQty * pct);
        }
    }

    geTotalQuantityLabel() {

        const { bulkAdjustment, unit } = this

        if (bulkAdjustment) {
            const qty = bulkAdjustment.planQty
            return getTotalQtyLabel(qty, unit)
        }

    }

}
